<template>
  <a-simple-tooltip @tooltip-close="$emit('tooltip-close')">
    <template #text>
      {{ $translate('post.tooltip.superLikeQuota.titleA') }}
      <strong class="anz-strong">
        {{ $translate('post.tooltip.superLikeQuota.titleB') }}
      </strong>
    </template>
  </a-simple-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import { Post } from '@/model/data-object/Post'
import { useRouter } from '@/routing/router'
import usePostSuperLike from '@/composables/post-super-like/postSuperLike'
import ASimpleTooltip from '@/components/Ui/ASimpleTooltip.vue'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_SUPER_LIKE_QUOTA,
  emits: ['tooltip-close'],
  components: { ASimpleTooltip },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  setup(props) {
    return {
      ...usePostSuperLike(props.post as Post),
      ...useRouter(),
    }
  },
})
</script>
